import React from 'react';
import { InfoTip } from './InfoTip';

interface ThProps {
  /** Localized metric explanation (from metricTip). Shows a styled hover
   *  tooltip with a dotted underline + info icon when set. */
  tip?: string;
  align?: 'left' | 'right' | 'center';
  className?: string;
  children: React.ReactNode;
}

/** Table header cell with an optional metric-explanation tooltip (portal-based,
 *  not clipped by the table's scroll container). */
export const Th: React.FC<ThProps> = ({ tip, align = 'left', className = '', children }) => {
  const alignCls = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : '';
  const justify = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : '';
  return (
    <th className={`px-4 py-3 font-medium text-slate-700 dark:text-slate-300 ${alignCls} ${className}`}>
      <InfoTip tip={tip} className={justify}>{children}</InfoTip>
    </th>
  );
};
